<template>
  <div class="media">

    <div class="media-wrapper">
      <div class="zlxc-container" style="overflow: visible">
        <!-- <div class="bread-crumbs">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>理论学习</el-breadcrumb-item>
            <el-breadcrumb-item to="videoLearning">结业鉴定</el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->
        <iframe src="http://192.168.1.3:8083/#/graduation" allowfullscreen=“true”  frameborder="0" width="100%" height="600px"></iframe>
        <div class="div-50" ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
  },
  created() { },
  methods: {

  },
  watch: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
